import KualiProgramList from 'components/KualiProgramList';

const Kuali = () => {
  return <KualiProgramList programType="undergrad" />;
};

export default Kuali;
